<template>
	<div class="not-found">
		<div class="not-found__content">
			<h1>
				<img class="logo" src="@/assets/img/icon/logo_red.png" alt="giftshow biz" />
				<span class="txt_hidden">giftshow biz</span>
			</h1>
			<p class="title">
				<span>세상 모든 판촉물</span>
				<span>기쇼비즈 판촉</span>
			</p>

			<p class="description">
				<span>기프티쇼 판촉 서비스는</span>
				<span>고객이 원하는 대로 판촉물, 기념물, 홍보물을</span>
				<span>주문, 제작, 배송해드리는 서비스입니다.</span>
			</p>

			<span class="notice">판촉 서비스는 <span>PC 버전에서 이용</span>하실 수 있습니다.</span>

			<div class="promotion-check">
				<span>판촉물을 주문 하셨나요?</span>
				<span>주문하신 판촉물의 시안을 확인해보세요.</span>
			</div>

			<div class="link-box">
				<router-link to="/panchok/orders" class="button">판촉 시안 확인</router-link>
				<router-link to="/" class="link">기프티쇼 비즈 홈 가기</router-link>
			</div>
		</div>

		<p class="not-found__copy">Copyright ⓒ kt alpha Co., Ltd. All rights reserved</p>
	</div>
</template>

<script>
export default {
	name: 'PanchokNotFound',
};
</script>

<style scoped lang="less">
.not-found {
	display: flex;
	flex-direction: column;
	height: 100dvh;
	padding: 0 24px 16px;

	&__content {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.logo {
			height: 18px;
			width: auto;
		}

		.title {
			display: flex;
			flex-direction: column;
			font-size: 36px;
			font-weight: bold;
			line-height: 1.33;
			letter-spacing: -1.8px;
			text-align: center;
			color: #111;
			margin-top: 16px;
			padding: 0;
		}

		.description {
			margin-top: 36px;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: -0.35px;
			color: #111;
		}

		.notice {
			font-weight: bold;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: -0.35px;
			margin-top: 36px;
			margin-bottom: 80px;

			> span {
				color: #ed2024;
			}
		}

		.promotion-check {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 4px;
			margin-bottom: 24px;

			> span:first-of-type {
				font-size: 18px;
				font-weight: bold;
				letter-spacing: -0.45px;
				color: #000;
			}

			> span:last-of-type {
				font-size: 14px;
				letter-spacing: -0.35px;
				color: #111;
			}
		}

		.link-box {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;
			gap: 24px;

			.button {
				width: 100%;
				height: 50px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #111;
				border-radius: 3px;
				font-size: 14px;
				font-weight: bold;
				letter-spacing: -0.35px;
				color: #fff;
			}

			.link {
				font-size: 14px;
				letter-spacing: -0.35px;
				color: #111;
				border-bottom: 1px solid #111;
			}
		}
	}

	&__copy {
		text-align: center;
		font-family: Montserrat;
		font-size: 10px;
		letter-spacing: -0.25px;
		color: #888;
	}
}
</style>
